
import { ColumnDefinitionInterface } from "../../app/components/Table";
import { DropdownValue, NumberDropdownValue } from "../components/Dropdown";

import { FiltersType, ViewDataType } from "../duck/types";


export const DEFAULT_REPORT_FILTERS: FiltersType = {
    countryCode: {
        label: "us",
        name: "United States of America (USA)",
        value: "usa"
    },
    deviceType: { label: "Desktop", value: "DESKTOP" },
    searchType: { label: "Web", value: "web" },
    keywordsFilters: {
        connector: "AND",
        list: []
    },
    urlsFilter: {
        connector: "AND",
        list: []
    },
    keywordUrlConnector: { label: "and", value: "AND" },
    metricsFilters: {
        connector: "AND",
        list: []
    }
};

export const VIEWS_COLUMN_LIST = (renderMethods: {
    render_filters: (row: ViewDataType) => JSX.Element,
    render_action: (row: ViewDataType) => JSX.Element,
    render_created_by: (row: ViewDataType) => JSX.Element,
    render_updated_by: (row: ViewDataType) => JSX.Element
}): ColumnDefinitionInterface[] => [
        {
            key: "title",
            displayName: "Report",
            width: "22%",
            align: "left",
            column: "title",
            isSortable: true,
        },
        {
            key: "filters",
            displayName: "Applied Filters",
            width: "34%",
            align: "left",
            column: "filters",
            isSortable: false,
            render: renderMethods.render_filters
        },
        {
            key: "created_by",
            displayName: "Created",
            width: "17%",
            align: "left",
            column: "created_by",
            isSortable: true,
            render: renderMethods.render_created_by
        },
        {
            key: "updated_by",
            displayName: "Last Updated",
            width: "17%",
            align: "left",
            column: "updated_by",
            isSortable: true,
            render: renderMethods.render_updated_by
        },
        {
            key: "id",
            displayName: "Action",
            width: "10%",
            align: "left",
            column: "id",
            isSortable: false,
            render: renderMethods.render_action
        }
    ];

export const DEFAULT_VIEW_DATA = (tenantCode: string, domainUrl: string): ViewDataType => ({
    _id: "default",
    tenant_code: tenantCode,
    project_id: 111,
    title: "⭐  Default View",
    domain_url: domainUrl,
    filters: {
        countryCode: {
            label: "us",
            name: "United States of America (USA)",
            value: "usa"
        },
        deviceType: { label: "Desktop", value: "DESKTOP" },
        searchType: { label: "Web", value: "web" },
        keywordsFilters: {
            connector: "AND",
            list: []
        },
        urlsFilter: {
            connector: "AND",
            list: []
        },
        keywordUrlConnector: { label: "and", value: "AND" },
        metricsFilters: {
            connector: "AND",
            list: []
        }
    },
    created_by: "-",
    updated_by: "-",
    created_at: "-",
    updated_at: "-",
});


export const REPORT_COLUMN_LIST: ColumnDefinitionInterface[] = [
    {
        key: "KEYWORD",
        displayName: "Keyword",
        width: "20%",
        align: "left",
        column: "KEYWORD",
        isSortable: true,
    },
    {
        key: "URL",
        displayName: "Page URL",
        width: "28%",
        align: "left",
        column: "URL",
        isSortable: true,
    },
    {
        key: "CLICKS",
        displayName: "Clicks",
        width: "13%",
        align: "right",
        column: "CLICKS",
        isSortable: true,
    },
    {
        key: "IMPRESSIONS",
        displayName: "Impressions",
        width: "13%",
        align: "right",
        column: "IMPRESSIONS",
        isSortable: true,
    },
    {
        key: "CTR",
        displayName: "CTR",
        width: "13%",
        align: "right",
        column: "CTR",
        isSortable: true,
    },
    {
        key: "POSITION",
        displayName: "Position",
        width: "13%",
        align: "right",
        column: "POSITION",
        isSortable: true,
    },
];

export const OperatorLabelMapper: Record<string, string> = {
    LTE: "<=",
    GTE: ">=",
    EQ: "=",
    GT: ">",
    LT: "<",
};
export const OperatorOptions: DropdownValue[] = Object.entries(OperatorLabelMapper).map(([value, label]) => ({ label, value }));

export const FieldLabelsMapper: Record<string, string> = {
    CLICKS: "Clicks",
    IMPRESSIONS: "Impressions",
    CTR: "CTR",
    POSITION: "Position",
};
export const FieldOptions: DropdownValue[] = Object.entries(FieldLabelsMapper).map(([value, label]) => ({ label, value }));

export const MAX_FILTERS_COUNT = 5;

export const CONNECTOR_NAME_MAPPINGS = {
    AND: "and",
    OR: "or"
};
export const CONNECTOR_TYPES = Object.keys(CONNECTOR_NAME_MAPPINGS);

export const FILTER_NAME_MAPPINGS = {
    EQUALS: "Equals",
    CONTAINS: "Contains",
    STARTS_WITH: "Starts With",
    NOT_CONTAINS: "Does Not Contain",
    REGEX: "Regex Match",
    NOT_REGEX: "Regex Does Not Match",
};
export const FILTER_TYPES = ["EQUALS", "CONTAINS", "STARTS_WITH", "NOT_CONTAINS", "REGEX", "NOT_REGEX"] as const;

export const DeviceTypeOptions: DropdownValue[] = [
    { label: "Overall", value: "ALL" },
    { label: "Desktop", value: "DESKTOP" },
    { label: "Mobile", value: "MOBILE" },
    { label: "Tablet", value: "TABLET" }
];

export const SearchTypeOptions: DropdownValue[] = [
    { label: "News", value: "news" },
    { label: "Web", value: "web" },
    { label: "Image", value: "image" },
    { label: "Video", value: "video" }
];

export const ItemsPerPageOptions: NumberDropdownValue[] = [
    { label: "10", value: 10 },
    { label: "25", value: 25 },
    { label: "50", value: 50 },
    { label: "100", value: 100 },
];

export const COUNTRIES = [
    {
        name: "Angola (AGO)",
        country: "ao",
        code: "ago"
    },
    {
        name: "United Arab Emirates (ARE)",
        country: "ae",
        code: "are"
    },
    {
        name: "Argentina (ARG)",
        country: "ar",
        code: "arg"
    },
    {
        name: "Australia (AUS)",
        country: "au",
        code: "aus"
    },
    {
        name: "Austria (AUT)",
        country: "at",
        code: "aut"
    },
    {
        name: "Belgium (BEL)",
        country: "be",
        code: "bel"
    },
    {
        name: "Bangladesh (BGD)",
        country: "bd",
        code: "bgd"
    },
    {
        name: "Bulgaria (BGR)",
        country: "bg",
        code: "bgr"
    },
    {
        name: "Bahrain (BHR)",
        country: "bh",
        code: "bhr"
    },
    {
        name: "Bahamas (BHS)",
        country: "bs",
        code: "bhs"
    },
    {
        name: "Belize (BLZ)",
        country: "bz",
        code: "blz"
    },
    {
        name: "Bolivia (Plurinational State of) (BOL)",
        country: "bo",
        code: "bol"
    },
    {
        name: "Brazil (BRA)",
        country: "br",
        code: "bra"
    },
    {
        name: "Brunei Darussalam (BRN)",
        country: "bn",
        code: "brn"
    },
    {
        name: "Canada (CAN)",
        country: "ca",
        code: "can"
    },
    {
        name: "Switzerland (CHE)",
        country: "ch",
        code: "che"
    },
    {
        name: "Chile (CHL)",
        country: "cl",
        code: "chl"
    },
    {
        name: "Cameroon (CMR)",
        country: "cm",
        code: "cmr"
    },
    {
        name: "Congo (the Democratic Republic of the) (COD)",
        country: "cd",
        code: "cod"
    },
    {
        name: "Colombia (COL)",
        country: "co",
        code: "col"
    },
    {
        name: "Cabo Verde (CPV)",
        country: "cv",
        code: "cpv"
    },
    {
        name: "Costa Rica (CRI)",
        country: "cr",
        code: "cri"
    },
    {
        name: "Czechia (CZE)",
        country: "cz",
        code: "cze"
    },
    {
        name: "Germany (DEU)",
        country: "de",
        code: "deu"
    },
    {
        name: "Denmark (DNK)",
        country: "dk",
        code: "dnk"
    },
    {
        name: "Dominican Republic (DOM)",
        country: "do",
        code: "dom"
    },
    {
        name: "Algeria (DZA)",
        country: "dz",
        code: "dza"
    },
    {
        name: "Ecuador (ECU)",
        country: "ec",
        code: "ecu"
    },
    {
        name: "Egypt (EGY)",
        country: "eg",
        code: "egy"
    },
    {
        name: "Spain (ESP)",
        country: "es",
        code: "esp"
    },
    {
        name: "Estonia (EST)",
        country: "ee",
        code: "est"
    },
    {
        name: "Finland (FIN)",
        country: "fi",
        code: "fin"
    },
    {
        name: "France (FRA)",
        country: "fr",
        code: "fra"
    },
    {
        name: "United Kingdom of Great Britain and Northern Ireland (GBR)",
        country: "gb",
        code: "gbr"
    },
    {
        name: "Ghana (GHA)",
        country: "gh",
        code: "gha"
    },
    {
        name: "Greece (GRC)",
        country: "gr",
        code: "grc"
    },
    {
        name: "Guatemala (GTM)",
        country: "gt",
        code: "gtm"
    },
    {
        name: "Guyana (GUY)",
        country: "gy",
        code: "guy"
    },
    {
        name: "Hong Kong (HKG)",
        country: "hk",
        code: "hkg"
    },
    {
        name: "Honduras (HND)",
        country: "hn",
        code: "hnd"
    },
    {
        name: "Croatia (HRV)",
        country: "hr",
        code: "hrv"
    },
    {
        name: "Haiti (HTI)",
        country: "ht",
        code: "hti"
    },
    {
        name: "Hungary (HUN)",
        country: "hu",
        code: "hun"
    },
    {
        name: "Indonesia (IDN)",
        country: "id",
        code: "idn"
    },
    {
        name: "India (IND)",
        country: "in",
        code: "ind"
    },
    {
        name: "Ireland (IRL)",
        country: "ie",
        code: "irl"
    },
    {
        name: "Iceland (ISL)",
        country: "is",
        code: "isl"
    },
    {
        name: "Israel (ISR)",
        country: "il",
        code: "isr"
    },
    {
        name: "Italy (ITA)",
        country: "it",
        code: "ita"
    },
    {
        name: "Jamaica (JAM)",
        country: "jm",
        code: "jam"
    },
    {
        name: "Jordan (JOR)",
        country: "jo",
        code: "jor"
    },
    {
        name: "Japan (JPN)",
        country: "jp",
        code: "jpn"
    },
    {
        name: "Kazakhstan (KAZ)",
        country: "kz",
        code: "kaz"
    },
    {
        name: "Korea (the Republic of) (KOR)",
        country: "kr",
        code: "kor"
    },
    {
        name: "Kuwait (KWT)",
        country: "kw",
        code: "kwt"
    },
    {
        name: "Lebanon (LBN)",
        country: "lb",
        code: "lbn"
    },
    {
        name: "Libya (LBY)",
        country: "ly",
        code: "lby"
    },
    {
        name: "Sri Lanka (LKA)",
        country: "lk",
        code: "lka"
    },
    {
        name: "Lithuania (LTU)",
        country: "lt",
        code: "ltu"
    },
    {
        name: "Luxembourg (LUX)",
        country: "lu",
        code: "lux"
    },
    {
        name: "Latvia (LVA)",
        country: "lv",
        code: "lva"
    },
    {
        name: "Morocco (MAR)",
        country: "ma",
        code: "mar"
    },
    {
        name: "Moldova (the Republic of) (MDA)",
        country: "md",
        code: "mda"
    },
    {
        name: "Mexico (MEX)",
        country: "mx",
        code: "mex"
    },
    {
        name: "Malta (MLT)",
        country: "mt",
        code: "mlt"
    },
    {
        name: "Mozambique (MOZ)",
        country: "mz",
        code: "moz"
    },
    {
        name: "Mauritius (MUS)",
        country: "mu",
        code: "mus"
    },
    {
        name: "Malaysia (MYS)",
        country: "my",
        code: "mys"
    },
    {
        name: "Namibia (NAM)",
        country: "na",
        code: "nam"
    },
    {
        name: "Nigeria (NGA)",
        country: "ng",
        code: "nga"
    },
    {
        name: "Nicaragua (NIC)",
        country: "ni",
        code: "nic"
    },
    {
        name: "Netherlands (NLD)",
        country: "nl",
        code: "nld"
    },
    {
        name: "Norway (NOR)",
        country: "no",
        code: "nor"
    },
    {
        name: "New Zealand (NZL)",
        country: "nz",
        code: "nzl"
    },
    {
        name: "Oman (OMN)",
        country: "om",
        code: "omn"
    },
    {
        name: "Pakistan (PAK)",
        country: "pk",
        code: "pak"
    },
    {
        name: "Panama (PAN)",
        country: "pa",
        code: "pan"
    },
    {
        name: "Peru (PER)",
        country: "pe",
        code: "per"
    },
    {
        name: "Philippines (PHL)",
        country: "ph",
        code: "phl"
    },
    {
        name: "Poland (POL)",
        country: "pl",
        code: "pol"
    },
    {
        name: "Portugal (PRT)",
        country: "pt",
        code: "prt"
    },
    {
        name: "Paraguay (PRY)",
        country: "py",
        code: "pry"
    },
    {
        name: "Qatar (QAT)",
        country: "qa",
        code: "qat"
    },
    {
        name: "Romania (ROU)",
        country: "ro",
        code: "rou"
    },
    {
        name: "Russian Federation (RUS)",
        country: "ru",
        code: "rus"
    },
    {
        name: "Saudi Arabia (SAU)",
        country: "sa",
        code: "sau"
    },
    {
        name: "Senegal (SEN)",
        country: "sn",
        code: "sen"
    },
    {
        name: "Singapore (SGP)",
        country: "sg",
        code: "sgp"
    },
    {
        name: "El Salvador (SLV)",
        country: "sv",
        code: "slv"
    },
    {
        name: "Serbia (SRB)",
        country: "rs",
        code: "srb"
    },
    {
        name: "Slovakia (SVK)",
        country: "sk",
        code: "svk"
    },
    {
        name: "Slovenia (SVN)",
        country: "si",
        code: "svn"
    },
    {
        name: "Sweden (SWE)",
        country: "se",
        code: "swe"
    },
    {
        name: "Thailand (THA)",
        country: "th",
        code: "tha"
    },
    {
        name: "Trinidad and Tobago (TTO)",
        country: "tt",
        code: "tto"
    },
    {
        name: "Tunisia (TUN)",
        country: "tn",
        code: "tun"
    },
    {
        name: "Turkey (TUR)",
        country: "tr",
        code: "tur"
    },
    {
        name: "Taiwan (Province of China) (TWN)",
        country: "tw",
        code: "twn"
    },
    {
        name: "Ukraine (UKR)",
        country: "ua",
        code: "ukr"
    },
    {
        name: "Uruguay (URY)",
        country: "uy",
        code: "ury"
    },
    {
        name: "United States of America (USA)",
        country: "us",
        code: "usa"
    },
    {
        name: "Venezuela (Bolivarian Republic of) (VEN)",
        country: "ve",
        code: "ven"
    },
    {
        name: "Viet Nam (VNM)",
        country: "vn",
        code: "vnm"
    },
    {
        name: "South Africa (ZAF)",
        country: "za",
        code: "zaf"
    },
    {
        name: "Zambia (ZMB)",
        country: "zm",
        code: "zmb"
    },
    {
        name: "Zimbabwe (ZWE)",
        country: "zw",
        code: "zwe"
    }
];
